export default "__VITE_PUBLIC_ASSET__71ffa6ad__"